<div class="sidenav-container">
    <app-sidenav-header [title]="title" [subtitle]="subtitle | titlecase"></app-sidenav-header>
    <div *ngIf="data" class="cob-dialog-wrapper hover-container">
        <div class="flex flex-col">
            <div class="flex flex-row w-100-percent json-line-wrapper pl-6">
                <div class="json-data flex flex-col">
                    <div class="json-line" *ngFor="let line of formattedBody; let i = index">
                        <span class="line-number">{{ i + 1 }}.</span>
                        <span class="line-content">{{ line }}</span>
                    </div>
                </div>
                <div>
            <button [ngClass]="[copyFormatedJson ? 'copied': 'copy']" class=" copy-btn mr-8 mt-8 flex justify-end h-30 pt-4 pr-8 pb-4 pl-8" (click)="copyText()">
                <span *ngIf="!copyFormatedJson" class="fs-16 fw-500 item flex items-center">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' | transloco }}
                </span>
                <span *ngIf="copyFormatedJson" class="fs-16 fw-500 item flex items-center copied-text">
                  <mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco }}
                </span>
            </button>
                </div>
            </div>
        </div>
    </div>
</div>